export default "__VITE_ASSET__lxNYIpxf__"